import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useOnboarding } from '../context';
import { previousDiagnosis } from '../record';
import { ResultReport } from './result';

/**
 * 결과 화면(덱 p10) — 컨텍스트 어댑터. 그리는 건 `ResultReport`가 한다.
 *
 * **회차 레코드가 값의 정본이다.** 녹음이 끝나는 순간(useRecordMachine) 리포트와 레코드가
 * 같이 실리므로 둘은 항상 함께 있다 — 하나만 있으면 그건 버그이고, 화면은 재녹음으로
 * 되돌린다(없는 값을 0으로 그리는 대신).
 *
 * 나가는 길은 플로우의 마지막 `next` — 무엇을 하는지는 페이지가 정한다(`onComplete`:
 * 드래프트를 지우고 홈으로). 결과를 보다 새로고침한 경우는 `OnboardingPage`의
 * `restartFinishedRun`이 같은 일을 한다.
 */

export const ResultView = () => {
  const { t } = useTranslation();
  const { report, record, back, next } = useOnboarding();
  // 기준선은 localStorage를 읽는다 — 렌더마다 다시 읽지 않도록 회차가 바뀔 때만 뽑는다.
  const previous = useMemo(
    () => (record ? previousDiagnosis(record) : null),
    [record],
  );

  if (!report || !record) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-4 text-center">
        <h2 className="text-xl font-bold">{t('web.result.failed.title')}</h2>
        <p className="text-sm text-muted-foreground">
          {t('web.result.failed.body')}
        </p>
        <button
          type="button"
          onClick={back}
          className="rounded-xl bg-primary px-6 py-3 font-semibold text-primary-foreground"
        >
          {t('web.result.failed.retry')}
        </button>
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col gap-6">
      <ResultReport record={record} previous={previous} />
      <button
        type="button"
        onClick={next}
        className="mt-auto w-full rounded-xl bg-primary py-4 font-semibold text-primary-foreground"
      >
        {t('web.result.cta')}
      </button>
    </div>
  );
};
